import {
  faClock,
  faPaperPlane,
  faPencil,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { Card, CardBody, NavLink } from 'reactstrap'
import moment from 'moment'
import { setJobDetailRoute } from 'store/Recruitment/actions'
import { useDispatch } from 'react-redux'
import { JOB_DETAIL_DETAILS } from 'store/Recruitment/reducer'
import { JOB_DETAIL_QUESTIONS } from 'store/Recruitment/reducer'
import { JOB_DETAIL_DESCRIPTIONS } from 'store/Recruitment/reducer'
import { JOB_DETAIL_APPLICATIONS } from 'store/Recruitment/reducer'
import { JOB_DETAIL_NOTES } from 'store/Recruitment/reducer'
import { JOB_DETAIL_TODO } from 'store/Recruitment/reducer'
import { useEffect } from 'react'
import { getJobs } from 'store/Recruitment/actions'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import Details from './Details'
import Questions from './Questions'
import Descriptions from './Descriptions'
import Applications from './Applications'
import Notes from './Notes'
import Todo from './Todo'
import { updateJobPublicationStatus } from 'store/Recruitment/actions'
import { AI_INTERVIEW_RANKINGS } from 'store/Recruitment/reducer'
import AiInterviewRankings from './AiInterviewRankings'
import { APPEALS } from 'store/Recruitment/reducer'
import Appeals from './Appeals'

import "./style.css"

function JobDetails() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const { jobProps, currentJobDetailRoute } = useSelector(
    (store) => store.recruitment
  )
  const createdDate = jobProps?.find((el) => el?.name === 'created_at')
  const publicationStatus = jobProps?.find(
    (el) => el?.name === 'publication_status'
  )

  useEffect(() => {
    if (!jobProps.length) {
      dispatch(getJobs(location?.search?.split('=')?.at(1)))
    }
  }, [jobProps?.length, location?.search, dispatch])

  return (
    <>
      <Card>
        <CardBody className='job-details-container d-flex justify-content-between'>
          <div className='button-text-wrapper w-50 d-flex flex-column' style={{ gap: '0.5rem' }}>
            <div>
              <FontAwesomeIcon icon={faClock} /> Created on{' '}
              {moment(createdDate?.value).format('DD-MM-YYYY')}
            </div>
            <button
              onClick={() =>
                history.push(
                  `/job/edit?job=${location?.search?.split('=')?.at(1)}`
                )
              }
              className='details-btn btn btn-info'
              style={{ width: 'fit-content' }}
            >
              <FontAwesomeIcon icon={faPencil} className='mr-1' />
              Edit Job
            </button>
          </div>
          <div
            className='button-text-wrapper w-50 text-capitalize d-flex flex-column'
            style={{ gap: '0.5rem' }}
          >
            <div className='status'>Status: {publicationStatus?.value}</div>
            <button
              onClick={() =>
                dispatch(
                  updateJobPublicationStatus(
                    location?.search?.split('=')?.at(1),
                    publicationStatus?.value === 'draft' ? 'posted' : 'draft'
                  )
                )
              }
              className='details-btn btn btn-info'
              style={{ width: 'fit-content' }}
            >
              <FontAwesomeIcon icon={faPaperPlane} className='mr-1' />
              {publicationStatus?.value === 'draft'
                ? 'Post Job'
                : 'Unpublish Job'}
            </button>
          </div>
        </CardBody>
      </Card>
      <div className='settings-tabs dFlex md-flexCol textCenter gap-10 py-1 current border'>
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_DETAILS))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_DETAILS ? 'current' : ''
          }`}
        >
          Details
        </NavLink>
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_QUESTIONS))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_QUESTIONS ? 'current' : ''
          }`}
        >
          Questions
        </NavLink>
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_DESCRIPTIONS))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_DESCRIPTIONS ? 'current' : ''
          }`}
        >
          Descriptions
        </NavLink>
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_APPLICATIONS))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_APPLICATIONS ? 'current' : ''
          }`}
        >
          Applications
        </NavLink>{' '}
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(AI_INTERVIEW_RANKINGS))}
          className={`${
            currentJobDetailRoute === AI_INTERVIEW_RANKINGS ? 'current' : ''
          }`}
        >
          AI Interview Rankings
        </NavLink>
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(APPEALS))}
          className={`${currentJobDetailRoute === APPEALS ? 'current' : ''}`}
        >
          Appeals
        </NavLink>
        {/* <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_NOTES))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_NOTES ? 'current' : ''
          }`}
        >
          Notes
        </NavLink>{' '}
        <NavLink
          onClick={() => dispatch(setJobDetailRoute(JOB_DETAIL_TODO))}
          className={`${
            currentJobDetailRoute === JOB_DETAIL_TODO ? 'current' : ''
          }`}
        >
          To Do
        </NavLink> */}
      </div>

      {currentJobDetailRoute === JOB_DETAIL_DETAILS && <Details />}
      {currentJobDetailRoute === JOB_DETAIL_QUESTIONS && <Questions />}
      {currentJobDetailRoute === JOB_DETAIL_DESCRIPTIONS && <Descriptions />}
      {currentJobDetailRoute === JOB_DETAIL_APPLICATIONS && <Applications />}
      {currentJobDetailRoute === JOB_DETAIL_NOTES && <Notes />}
      {currentJobDetailRoute === JOB_DETAIL_TODO && <Todo />}
      {currentJobDetailRoute === AI_INTERVIEW_RANKINGS && (
        <AiInterviewRankings />
      )}
      {currentJobDetailRoute === APPEALS && (
        <Appeals jobId={location?.search?.split('=')?.at(1)} />
      )}
    </>
  )
}

export default JobDetails
